import { Button, Grid, Image, Text } from "@chakra-ui/react";
import React from "react";
import { Reward } from "../store/RewardsStore";
import { LockIcon } from "@chakra-ui/icons";

type RewardItemProps = {
  reward: Reward;
  hasEnoughPoints: boolean;
  onClaim: () => void;
  spendable: number;
}

export const RewardItem: React.FC<RewardItemProps> = ({ reward, hasEnoughPoints, onClaim, spendable }) => {
  return (
    <Grid maxW="500px" minW="380px" borderRadius="4px" overflow="hidden" m="0 1em">
      <Grid borderRadius="10px" overflow="hidden" gap="0.5em">
        <Grid>
          <Image opacity={hasEnoughPoints ? 1 : 0.5} src={reward.image.medium} />
          {!hasEnoughPoints && 
            <Text maxH="1.5em" textAlign="center" bg="brand.700">EARN {reward.points - spendable} MORE POINTS</Text>
          }
        </Grid>
        <Grid templateColumns="auto auto" placeContent="center" alignItems="center" gap="0.5em">
          <Text fontSize="16px" color="brand.500" fontWeight="bold">{reward.title.toUpperCase()}</Text>
          <Text color="brand.700" size="lg" fontWeight="bold" textAlign="end">
            -{reward.points} POINTS
          </Text>
        </Grid>
        <Text textAlign="center">{reward.description}</Text>
        <Button
          variant="mainSolid"
          loadingText="Loading..."
          isDisabled={!hasEnoughPoints}
          onClick={hasEnoughPoints ? onClaim : undefined}
          placeSelf="center"
          p="0.5em 3em"
          rightIcon={!hasEnoughPoints ? <LockIcon /> : undefined}
        >
            CLAIM REWARD
        </Button>
        </Grid>
      </Grid>
  )
}